import { ProjectContentItemDc } from "@evergis/api";

import { PrintLayer } from "../../../interfaces/print";
import { LayerInfo } from "../../../interfaces/resourceInfo";
import { combineLayers } from "../../../hooks/project/useProjectLayers";

export const getPrintLayers = (projectItems: ProjectContentItemDc[], layerInfos: LayerInfo[]): PrintLayer[] =>
  combineLayers(projectItems).reduce((printLayers: PrintLayer[], { name, opacity, isVisible }) => {
    const layerInfo = layerInfos.find(({ name: layerName }) => name === layerName);

    if (isVisible && layerInfo) {
      return [...printLayers, { layerServiceName: name, layerOpacity: opacity, ...layerInfo }];
    }

    return printLayers;
  }, []);
